import { Button } from "../../components/Button"; // Standardized Button component
import WelcomeMessage from "../shared/WelcomeMessage";
import { Link } from "react-router-dom";
import { AppRoutes } from "../../types/constants.types";
import useFormValues from "../../hooks/useFormValues";



const initForm = {
	name:"",
	email: "",
	password: "",
};


export default function RequestLoginForm() {
    const { values, handleOnChange, refresh } = useFormValues(initForm);
	const handleSubmit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		e.preventDefault();
		console.log({ values: values });

		// Do Submit work.
		refresh();
	};
    

	return (
		<div className="p-2 w-full h-full flex flex-col items-start justify-center ml-4 gap-1">
			<WelcomeMessage />
			<div className="w-3/4">
				<span className="tex-sm font-light">
					{" "}
					Please enter your details to request a login{" "}
                     
				</span>
			</div>
			<div className="w-full flex">
				<form className="w-3/4 flex-col flex gap-3">
					<input
						type="text"
						placeholder="Name"
						value={values?.name || ''}
						onChange={(e) => handleOnChange('name', e.target.value)}
						className="w-full border border-gray-300 rounded-md p-2 focus:ring-primary-100 focus:border-primary-100"
					/>
					<input
						type="email"
						placeholder="Email"
						value={values?.email || ''}
						onChange={(e) => handleOnChange('email', e.target.value)}
						className="w-full border border-gray-300 rounded-md p-2 focus:ring-primary-100 focus:border-primary-100"
					/>
					<input
						type="password"
						placeholder="Password"
						value={values?.password || ''}
						onChange={(e) => handleOnChange('password', e.target.value)}
						className="w-full border border-gray-300 rounded-md p-2 focus:ring-primary-100 focus:border-primary-100"
					/>
					<div className="flex flex-row justify-evenly"></div>
					<div className="flex flex-row justify-end items-end text-end w-full">
						<Button variant="primary" value="REQUEST" onClick={(e:any)=>handleSubmit(e)}/>
					</div>
					<div className="flex flex-col justify-center text-center w-full">
						<div><span>If you have valid credentials , Please</span></div>
                        <div><Link to={AppRoutes.LOGIN} className="underline text-lg text-primary-100">Sign-In</Link></div>
					</div>
                    
				</form>
			</div>
		</div>
	);
}
